import { InitialState } from "../Interfaces";

export const initialState: InitialState = {
  initialValues: {
    fileType: null,
    creditor: null,
  },
  fileList: [],
  preview: {
    data: {},
    isLoading: false,
  },
  importFiles: {
    data: {},
    isLoading: false,
  },
  creditorsAndProfiles: {
    data: [],
    isLoading: false,
  },
};
